<template>
    <v-app id="app">

        <v-layout row>

            <v-flex lg12 class="mt-10 px-3">
           
                <v-row justify-lg="end" justify-sm="start" class="ml-lg-12 ml-1 mt-lg-0 mt-2">

                    <v-col cols="1" lg="6" xs="12">

                        <v-row style="width:300px !important;">
                             <v-col lg="10" xs="12">   <v-autocomplete
                                v-model="month"
                                :items="months"
                                item-text="month"
                                item-value="no"
                                dense
                                class="ml-lg-0"
                                prepend-icon="mdi-calendar"
                                label="MONTH"
                                @change="fetchDataAttendance()()"
                            
                            ></v-autocomplete>  </v-col>

                        </v-row>

                    </v-col>

                </v-row>
                
                <v-data-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" hide-default-footer items-per-page="12"  :items="tables" item-key="name" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr @click="getDataForm(props.item)">
                                            <td class="text-center"> {{props.item.name}} </td>
                                            <td class="text-center"> {{infraction[props.item.infraction]}} </td>
                                            <td class="text-center"> {{props.item.date}} </td>
                                            

                                        </tr>

                                    </template>


                </v-data-table> 

                <div class="px-lg-4">

                    <v-btn depressed color="add-new" @click="addnew()"> ADD NEW </v-btn>

                </div>

            </v-flex>
        
        </v-layout>


    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'complaintsForm',
    props:['report','backData'],
    data: () => ({
        month:'',
        months: [{'no':'01','month':'January'}, {'no':'02','month':'February'}, {'no':'03','month':'March'}, {'no':'04','month':'April'}, {'no':'05','month':'May'}, {'no':'06','month':'June'}, {'no':'07','month':'July'}, {'no':'08','month':'August'}, {'no':'09','month':'September'}, {'no':'10','month':'October'}, {'no':'11','month':'November'}, {'no':'12','month':'December'},],
        tables:[],
        getTutor:[],
        itemPerPage:0,
        tutorName:'',
        infraction:['','Unexcused Absence','Undertime','Tardy','Missed Class'],
        data_id:'',
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Name',
          align: 'center',
          sortable: false,
          value: 'name',
          class: "grey lighten-2"
        },
        { text: 'Infraction',align: 'center', value: 'infraction' , class: "grey lighten-2", sortable: false,},
        { text: 'Date of Infraction',align: 'center', value: 'date' , class: "grey lighten-2", sortable: false,},
        
        ]}
    },
    mounted(){

        this.report.$on('updateNewData', this.updateNewData)


    },
    methods:{
       
        addnew(){
            let val = true
            this.$emit('addNewTrigger',val)
        },

        async fetchDataAttendance(){
            this.tables=[]
           await axios.get('http://localhost/megatalking/performance/tutorperf.php?actionTaken=getMonthAtten')
                //.then(response=>console.warn(response.data))
                .then(response=>{

                    const AllData = response.data
                     
                
                    for(let x = 0 ; x <= AllData.length; x++){

                        let dateInfraction = AllData[0].dateInfraction

                        let getDateInfraction = new Date(dateInfraction)
                        
                        let getMonthInfraction = (getDateInfraction.getMonth() >= 9 ? (getDateInfraction.getMonth()+1) : "0"+(getDateInfraction.getMonth()+1))
                        
                        if(getMonthInfraction == this.month){
                            this.tables.push({
                                data_id:x,
                                name:AllData[x].tutor_id,
                                tutor_id:AllData[x].tutor_id,
                                infraction:AllData[x].actTaken,
                                date:AllData[x].dateInfraction,
                                NoMC:AllData[x].NoMC,
                                utHr:AllData[x].utHr,
                                tarHr:AllData[x].tarHr,
                                details:AllData[x].details,
                                location:AllData[x].location,
                                position:AllData[x].position,
                                utMissed:AllData[x].utMissed,
                                tarMissed:AllData[x].tarMissed,
                                unexcused:AllData[x].unexcused,
                                NoAttempts:AllData[x].NoAttempts,
                                missedclass:AllData[x].missedclass,
                                chkUt:AllData[x].chkUt,
                                chkTar:AllData[x].chkTar,
                                status:'update'
                            })
                        }
                         
                        

                    }
                   


            }).catch(error=>console.log('this is the error '+error))
        },

        getDataForm(data){
            
            this.data_id = data.data_id
            this.$emit('getDataForm',data)

        },

        updateNewData(){
            
            let data = Vue.prototype.$backData
            let objIndex = this.tables.findIndex((obj => obj.data_id == this.data_id));

            this.tables[objIndex].infraction = data.actTaken
            this.tables[objIndex].date = data.dateInfraction
            this.tables[objIndex].NoMC=data.NoMC
            this.tables[objIndex].utHr=data.utHr
            this.tables[objIndex].tarHr=data.tarH
            this.tables[objIndex].details=data.details
            this.tables[objIndex].location=data.location
            this.tables[objIndex].position=data.position
            this.tables[objIndex].utMissed=data.utMissed
            this.tables[objIndex].tarMissed=data.tarMissed
            this.tables[objIndex].unexcused=data.unexcused
            this.tables[objIndex].NoAttempts=data.NoAttempts
            this.tables[objIndex].missedclass=data.missedclass
            this.tables[objIndex].chkUt=data.chkUt
            this.tables[objIndex].chkTar=data.chkTar

        }

        
    
 }
}
</script>
<style scoped>
.add-new{
    background-color: rgb(0, 157, 250) !important;
    color:white;
    font-weight: bold;
    font-size:10px;
}

</style>